/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import React, { PropsWithChildren, useState } from 'react';
import { Conversation } from '@/models';
import { DirectMessagesContext } from './direct-messages-context';

export const DirectMessagesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [conversationsReceived, setConversationsReceived] = useState<Conversation[]>([]);
  const [conversations, setConversations] = useState<Conversation[]>([]);

  return (
    <DirectMessagesContext.Provider
      value={{ conversationsReceived, conversations, setConversationsReceived, setConversations }}
    >
      {children}
    </DirectMessagesContext.Provider>
  );
};
